import React,{useState} from 'react'
// import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import AppBar from "./../Components/header/index"
// import SignInButton from "../../button/globleButtons";
import AppProvider from "./../Components/bootstrap/index"
import {useAuthenticated} from 'react-admin'

const useStyles = makeStyles(theme => ({
    '@global': {
      body: {
        backgroundColor: theme.palette.common.white,
      },
    },
    paper: {
      // marginTop: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height:"10vh",
      marginBottom:"25%"
    },
    avatar: {
      margin: 10,
      width: 300,
      height: 60,
      // margin: theme.spacing(1),
      backgroundColor: 'white',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    TextField:{
      marginTop:"10%",
      backgroundColor:"#ffffff"
    },
    coverBackgroundContainer: {
      backgroundColor:"#F7F8F9",
      height: "100%",
      backgroundSize: "cover",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft:"4%",
      paddingRight:"4%",
      // paddingTop:"90px",
      // paddingBottom:"20px",
    
    },
    // subtext1:{
    //   color:" black",
    //   background: "yellow"
    // },
    
  }));

  // const onclick='false';
  // const expand=(props)=>{
    
  //   console.log("***Clicked****",props)
    
          
  //   return(
  //     <div>
        
     
  //     <CancleAppointmentrequest/>
  //   </div>
  //   );
  // }

  const PreviousAppointment=(props)=>{
    useAuthenticated()
    const [Click,setClick]=useState('false');
    const [Clicks,setClicks]=useState('false');
    console.log("***Props*****",Click)
    console.log("***Props*****",Clicks)
    const classes = useStyles();
   return(
      <div className={classes.coverBackgroundContainer}>
         <Container component="main" maxWidth="xs" style={{width:"100%"}} >
       <Typography component="h6" variant="h6" style={{marginTop:"30%",textAlign:"center"}}>
          Appointment Request
        </Typography>
     <AppProvider >
    <AppBar/>
    
    {/* <Container component="main" maxWidth="xs" style={{background:"#ffffff",marginTop:"30%",marginBottom:"15%"}}> */}
    {/* <div className={classes.paper} > */}
   <div style={{marginTop:"0%"}}>
    <Box display="flex" justifyContent="flex-start" m={1} p={1} onClick={() => setClick(!Click)} style={{background:"white",}}>
      {Click==='false'?
      <Grid container >
      <Grid item xs={6}>
        <Box p={2} >
         <Grid container
                     style={
                             {
                                // paddingLeft: "8%",
                                // paddingRight: "8%",
                                marginTop:"13%"
                            }
                             }>
                            
                      <Grid item xs={12} sm={12}>
                           <Typography color="textPrimary"
                              className={
                                 classes.subText1
                           }>
                             Attendes (18)
                            
                           </Typography>
                      </Grid>
          </Grid>
    </Box>
    </Grid>
    <Grid item xs={6}>
     
        <Box p={1} >
          <Grid item  xs={12} sm={12}>
            <Typography color="textSecondary" className={ classes.subText1}>
                            Date & Time
                <Typography color="textPrimary">
                  24-05-2020 09:30 PM
                </Typography>
            </Typography>
          </Grid>
               {/* </Grid> */}
        </Box>
        
        </Grid>
        </Grid>
       : 
       <div>
         <Grid container  >
            <Grid item xs={12} style={{width:"100%"}}>
              
              {/* <Typography>afgfc</Typography> */}
            {/* <CancleAppointmentrequest/> */}
            </Grid>
        </Grid>
       </div>}
     </Box>
               
                          
    {/* </Container> */}

    {/* <Container component="main" maxWidth="xs" style={{background:"#ffffff",marginTop:"1%",marginBottom:"15%"}}> */}
    {/* <div className={classes.paper} > */}
   
    <Box display="flex" justifyContent="flex-start" m={1} p={1} onClick={() => setClicks(!Clicks)} style={{background:"white",marginTop:"10%",marginBottom:"5%"}}>
      {Clicks==='false'?
      <Grid container >
      <Grid item xs={6}>
        <Box p={2} >
         <Grid container
                     style={
                             {
                                // paddingLeft: "8%",
                                // paddingRight: "8%",
                                // marginTop:"13%"
                            }
                             }>
                            
                      <Grid item xs={12} sm={12}>
                           <Typography color="textPrimary"
                              className={
                                 classes.subText1
                           }>
                             Attendes (10)
                            
                           </Typography>
                      </Grid>
          </Grid>
    </Box>
    </Grid>
    <Grid item xs={6}>
     
        <Box p={1} >
          <Grid item  xs={12} sm={12}>
            <Typography color="textSecondary" className={ classes.subText1}>
                            Date & Time
                <Typography color="textPrimary">
                  24-05-2020 10:30 PM
                </Typography>
            </Typography>
          </Grid>
               {/* </Grid> */}
        </Box>
        </Grid>
        </Grid>
       : 
       <div style={{background:"white"}}>
    <Box display="flex" justifyContent="flex-start" m={1} p={1}   onClick={() => setClicks(!Clicks)} style={{background:"white",}}>
          
         <Grid container >
            <Grid item xs={12} style={{width:"100%",background:"white",}}>
              {/* <Typography>afgfc</Typography> */}
            {/* <CancleAppointmentrequest style={{width:"100%"}}/> */}
            </Grid>
        </Grid>
        {Clicks==='true'?
          setClicks('false'):null
          }
          </Box>
       </div>}
     </Box>
               
     </div>                 
    {/* </Container> */}

    </AppProvider>
    </Container>
        </div>
)
}
export default PreviousAppointment